module.exports = __webpack_public_path__ + "img/wait_payment.338580aa.svg";